import gql from 'graphql-tag';

export const MUTATION_DS_UpdateLandlord_ListingPlan = gql`
  mutation Dashboard_UpdateLandlord($input: UpdateLandlordDashboardInput!) {
    updateLandlordDashboard(input: $input) {
      landlord {
        listingPlan
      }
    }
  }
`;

export const QUERY_Landlord_ListingPlan = gql`
  query Landlord {
    viewer {
      ... on LandlordContact {
        company {
          listingPlan
          id
        }
      }
    }
  }
`;
